import Layout, {Content} from "antd/lib/layout/layout";
import React from "react";
import "./AppLayout.scss";

class AppLayout extends React.Component {

  render() {
    return (
      <div id="app-layout">
        <Layout>
          <Content>
            {this.props.children}
          </Content>
        </Layout>
      </div>
    );
  }
}

export default AppLayout;
